import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AutoAttendScheduleForm, PAY_PER_MEETING } from '@copilot/ui';
import { LANGUAGES, SPOKEN_LANGUAGE_OPTIONS } from '../../constants/languages';
import { useAuth } from '../../hooks/useAuth';
import * as botMeetingApi from '../../services/botMeetingApi';
import * as capabilitiesApi from '../../services/capabilitiesApi';
import { autoAttendDisplayName, botErrorInfo } from '../../utils/botMeetings';

// The shared Auto Attend form, wired to Web's API client.
function ScheduleAutoAttendForm({ onClose, onScheduled }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <AutoAttendScheduleForm
      botName={autoAttendDisplayName(user)}
      defaultSpokenLanguage={user?.preferences?.default_source_language}
      fallbackSpokenOptions={SPOKEN_LANGUAGE_OPTIONS}
      fallbackSummaryOptions={LANGUAGES}
      loadCapabilities={capabilitiesApi.getLanguageCapabilities}
      onSubmit={(values) => botMeetingApi.scheduleBotMeeting(values)}
      describeError={(err) =>
        botErrorInfo(err, 'Unable to schedule Auto Attend. Please try again.')
      }
      onScheduled={onScheduled}
      onClose={onClose}
      onOpenPlans={() => navigate('/app/billing/plans')}
      onBuyMeeting={() => navigate(PAY_PER_MEETING.buyPath)}
    />
  );
}

export default ScheduleAutoAttendForm;
